<template>
  <section>
    <div class="ProductCompare isNotInComparator" v-if="!isInComparator">
      <button v-if="!isInComparator" @click="checkAddToComparatorValue">
        <div class="ProductCompare-logo">
          <span class="ProductCompare-circle"></span>
          <span class="ProductCompare-circleDashed"></span>
        </div>
        <span>Comparer</span>
      </button>

      <!-- Modal Info -->
    </div>

    <div class="ProductCompare isInComparator" v-else>
      <button @click="removeToComparator">
        <div class="ProductCompare-logo">
          <span class="ProductCompare-circle"></span>
          <span class="ProductCompare-circleDashed"></span>
        </div>
        <span>Retirer</span>
      </button>
    </div>
    <transition name="slide-fade">
      <ModalConfirm
        v-if="showModalConfirm && !this.isProductCanBeAddToComparator"
        :showModal="showModalConfirm"
        @Modal::close="closeModalConfirm"
        @Modal::update="updateConsents"
        :content="modalContentConfirm"
      ></ModalConfirm>
    </transition>
  </section>
</template>

<script>
import InstanceApi from "@/services/apiClient.js";
import ModalConfirm from "@/components/Modal/ModalConfirm.vue";
import { mapGetters, mapActions } from "vuex";

import "@/includes/Product/ProductCompare/ProductCompare.scss";

export default {
  name: "ProductCompare",

  data () {
    return {
      isInComparator: false,
      showModalConfirm: false,
      modalContentConfirm:
        "<div class='ModalInfo-ComfirmText'><p>L'article que vous voulez comparer n'est pas comparable avec les articles dans le comparateur.<br> Si vous continuez, les articles présents dans le comparateur seront supprimés</p></div>",
    };
  },

  props: {
    productId: { Number, String },
  },

  components: {
    ModalConfirm,
  },

  computed: {
    ...mapGetters({
      comparatorStatus: "isProductInComparator",
      isProductCanBeAddToComparator: "isProductCanBeAddToComparator",
    }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },

  mounted () {
    this.isInComparator = this.comparatorStatus;
  },

  methods: {
    ...mapActions(["setAddItemInComparator", "setRemoveItemFromComparator"]),

    checkAddToComparatorValue () {
      if (!this.isProductCanBeAddToComparator) {
        this.showModalConfirm = true;
      } else {
        this.addToComparator();
      }
    },

    closeModalConfirm () {
      this.showModalConfirm = false;
    },

    async updateConsents () {
      const checkUrl = "mcp/product_compare/clear";
      try {
        const response = await InstanceApi.get(checkUrl);
        if (response.status === 200) {
          this.addToComparator();
        }
      } catch (e) {
        this.$fire({
          title: "Oups",
          text: "Impossible d'ajouter le produits au comparateur",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },

    async addToComparator () {
      const addUrl = "mcp/product_compare/add/product/" + this.productId;
      try {
        const response = await InstanceApi.get(addUrl);
        if (response.status === 200) {
          this.showModalConfirm = false;
          this.isInComparator = true;

          this.setAddItemInComparator(this.productId)
        }
      } catch (e) {
        this.$fire({
          title: "Oups",
          text: "Impossible d'ajouter le produits au comparateur",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },

    async removeToComparator () {
      const addUrl = "mcp/product_compare/remove/product/" + this.productId;
      try {
        const response = await InstanceApi.get(addUrl);
        if (response.status === 200) {
          this.isInComparator = false;

          this.setRemoveItemFromComparator(this.productId)
        }
      } catch (e) {
        this.$fire({
          title: "Oups",
          text: "Impossible de retirer le produits du comparateur",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },
  },
};
</script>
